<template>
  <div>
    <!-- {{ dropzoneOptions.url }} -->

    <label>{{ label }}</label>
    <!-- {{ mainImage }}
    {{ formModel }} -->
    <vue-dropzone
      v-if="dropzoneOptions.url"
      ref="myVueDropzone"
      id="dropzone"
      :key="dropzoneKey"
      :options="dropzoneOptions"
      @vdropzone-file-added="getFileName"
      @vdropzone-success="fileUploaded"
      @vdropzone-removed-file="onFileRemoved"
    ></vue-dropzone>
    <v-alert
      dismissible
      dense
      v-if="errorMessage != '' && errorMessage"
      type="error"
    >
      {{ errorMessage }}
    </v-alert>
    <v-snackbar
      v-if="successMessage"
      v-model="successMessage"
      :timeout="3000"
      color="success"
    >
      {{ successMessage }}

      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="successMessage = ''"> Close </v-btn>
      </template>
    </v-snackbar>
    <!-- <v-btn hidden type="icon" @click="submit">
      <v-icon>mdi-check</v-icon>
    </v-btn> -->
    <div v-if="docs && !uploadOnly">
      <h3 v-if="images.length">Images</h3>
      <div elevation-10 class="in-line" cols="4" v-for="s in images" :key="s">
        <v-checkbox
          v-if="images.length > 1"
          v-model="mainImage"
          :value="s"
          label="Main Image"
        ></v-checkbox>
        <img
          :style="'height:' + thumbnailHeight + 'px'"
          :src="dir + '/' + s.name"
        />

        <v-btn class="delete-icon" v-if="!noDelete" icon @click="deleteFile(s)"
          ><v-icon>mdi-close</v-icon></v-btn
        >
      </div>
      <h3 v-if="files.length">Files:</h3>
      <div elevation-10 class="in-line" cols="4" v-for="s in files" :key="s">
        <v-icon v-if="!s.dropbox">mdi-file</v-icon>
        <!-- {{ dir }} -->

        <a v-if="!s.dropbox" :href="dir + '/' + s.name" target="_blank">
          {{ s.name }}
        </a>

        <!-- <v-btn text small @click="getFromDropBox(s)" v-else>
          <v-icon>mdi-dropbox</v-icon>
          {{ s.name }}
        </v-btn> -->
        <v-btn
          class="delete-icon"
          v-if="!noDelete"
          icon
          @click="deleteFile(s, s.dropbox)"
          ><v-icon>mdi-close</v-icon></v-btn
        >
      </div>

      <v-expansion-panels v-if="sortedDropBoxFiles.length">
        <v-expansion-panel
          v-for="(d, i) in sortedDropBoxFiles"
          :key="`panel-${i}`"
        >
          <v-expansion-panel-header>
            <template v-slot:default="{ open }">
              <v-toolbar class="ma-n2" flat>
                <v-icon class="mr-2">mdi-video</v-icon>
                <!-- Icon with a right margin -->
                {{ d.title }}
                <v-spacer>
                  <v-btn
                    class="delete-icon"
                    v-if="!noDelete"
                    color="error"
                    icon
                    @click="deleteFile(d.title, true)"
                    ><v-icon>mdi-close</v-icon></v-btn
                  >
                </v-spacer>
              </v-toolbar>
            </template>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row>
              <v-col :key="`chunk-${j}`" v-for="(c, j) in d.chunks">
                <v-toolbar flat>
                  <v-btn text small @click="getFromDropBox(c)">
                    <v-icon>mdi-file-video</v-icon>
                    {{ c.name }}
                  </v-btn>

                  <!-- <v-btn
                    class="delete-icon"
                    v-if="!noDelete"
                    icon
                    color="error"
                    x-small
                    @click="deleteFile(c.path, true)"
                    ><v-icon>mdi-close</v-icon></v-btn
                  > -->
                </v-toolbar>

                <!-- {{ c }} -->
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>
  </div>
</template>

<script>
import vue2Dropzone from "vue2-dropzone";
import * as fun from "../plugins/common";
import "vue2-dropzone/dist/vue2Dropzone.min.css";

import axios from "axios";

export default {
  name: "UploadDragDrop",
  components: {
    vueDropzone: vue2Dropzone,
  },
  props: {
    label: String,
    objectName: String,
    formModel: [Object, Array],
    vModel: [String, Array, Object],
    filter: Array,
    filterExact: Boolean,
    parentKey: String,
    defaultMessage: String,
    autoUpload: Boolean,
    uploadFields: Array,
    uploadOnly: Boolean,
    convertPdfToImage: Boolean,
    data_object: Object,
  },
  data() {
    return {
      dropZone: null,
      successMessage: "",
      errorMessage: "",
      objName: "",
      dropzoneOptions: {
        url: fun.getServerURL() + "/upload_file",
        thumbnailHeight: 250,
        maxFilesize: 5,
        withCredentials: false,
        params: {
          folder: "",
        },
        // headers: {
        //   "Content-Type": "multipart/form-data",
        //   // enctype: "multipart/form-data",
        //   "Cache-Control": null,
        //   "X-Requested-With": null,
        // },

        autoProcessQueue: true,
        addRemoveLinks: true,
      },
      files: [],
      images: [],
      dir: "",
      fileLength: 0,
      thumbnailHeight: 128,
      recordId: "",
      portal: "",
      dropzoneKey: 0,
      imgExt: ["jpg", "jpeg", "gif", "png", "webp"],

      // accept: "image/jpeg,image/png,image/gif",
      acceptedFiles:
        ".gif,.jpg,.jpeg,.png,.pdf,.webm,.doc,.docx,.xls,.xlsx,.webp,.txt",

      mainImage: "",
      docs: 0,
      noDelete: true,
      par: null,
      dropBoxFiles: [],
      uploadedFiles: [],
      childPath: "",
    };
  },
  mounted() {
    var that = this;
    this.docs = 0;
    if (this.formModel && this.formModel.main_image) {
      this.mainImage = { name: this.formModel.main_image };
    }
    this.childPath = "";
    this.objName =
      this.parentKey || this.objectName
        ? this.objectName.replace(/^v_/, "")
        : "";
    this.checkDeletPermissions();
    this.par = fun.getParentByProperty(this, "shipmentId");

    if (this.defaultMessage) {
      this.dropzoneOptions.dictDefaultMessage = this.defaultMessage;
    }
    // if (this.autoUpload) {
    //   this.dropzoneOptions.autoProcessQueue = true;
    // }
    this.dropzoneKey = !this.dropzoneKey;
    this.dropZone = this.$refs.myVueDropzone;
    this.dropZone.dropzone.options.dictDefaultMessage = this.defaultMessage;
    if (this.formModel) {
      this.recordId = this.formModel._id;
    }
    if (this.par) {
      this.recordId = this.par.shipment._id;
      this.objName = "shipment";
      if (this.formModel.item && this.formModel.qty) {
        this.childPath = "\\inventory\\" + this.formModel._id;
      }
    }
    this.dropZone.options.params.upload_fields = this.uploadFields;
    this.dropZone.options.params.pdf_to_image = this.convertPdfToImage;
    //convertPdfToImage
    this.dropZone.options.params.object_name = this.objName;
    this.dropZone.options.params.folder =
      "portal_" +
      this.$root.portal_id +
      "\\" +
      this.objName +
      "\\" +
      this.recordId +
      this.childPath;
    // var myDropZone = that.$refs.myVueDropzone;
    this.dropZone.options.params.portal = "portal_" + that.$root.portal_id;
    // this.$root.$on("record_updated", (d) => {
    //   // that.dropZone = that.$refs.myVueDropzone;
    //   if (!d) return;

    //   if (
    //     d.data_object.object_name == that.objName ||
    //     d.data.object_name == that.objName
    //   ) {
    //     that.recordId = d.model._id;
    //     try {
    //       // that.dropZone.options
    //       that.dropZone.options.params.folder =
    //         "portal_" +
    //         that.$root.portal_id +
    //         "\\" +
    //         that.objName +
    //         "\\" +
    //         that.recordId;
    //       // var myDropZone = that.$refs.myVueDropzone;
    //       that.dropZone.options.params.portal =
    //         "portal_" + that.$root.portal_id;
    //       // that.dropZone.options.params.autoProcessQueue = true;
    //       // this.dropzoneKey = !this.dropzoneKey;
    //       that.dropZone.processQueue();
    //       // that.$refs.myVueDropzone.processQueue();
    //     } catch (error) {
    //       console.log(error);
    //       //
    //     }
    //   }
    // });

    this.portal =
      "portal_" + JSON.parse(localStorage.getItem("portalData")).portal_id;
    // this.$store.getters["auth/user"].portal_id;
    // if (!this.formModel._id) {
    //   this.formModel._id = fun.guid();
    // }

    this.getFiles({
      portal: this.portal,
      object_name: this.objName,
      record_id: this.recordId,
    });
    var isDev = window.location.host.indexOf("localhost") != -1 ? "public" : "";
    this.dir =
      "user_images/" +
      this.portal +
      "/" +
      this.objName +
      "/" +
      this.recordId +
      this.childPath;
    // this.getDropzoneUrl();
    console.log(this.dir);
  },
  beforeDestroy() {},
  methods: {
    deleteFromDropBox() {},
    getFromDropBox(f, isDelete) {
      var obj = this.objectName;
      var id = "";
      if (!obj) {
        try {
          obj = this.data_object["v-bind"].objectName;
          id = this.data_object["v-bind"]._id;
        } catch {
          //
        }
      }
      if (!id) {
        if (obj == "shipment") {
          if (this.par && this.par.shipment_id) {
            id = this.par.shipment_id;
          }
          if (this.formModel && this.formModel._id) {
            id = this.formModel._id;
          }
        }
      }

      f.path = "/" + obj + "/" + id + "/" + f.path;
      f.action = !isDelete ? "download" : "delete";

      axios
        .post(this.serverURL + "/get_file_dropbox", f, {
          withCredentials: true,
        })
        .then((response) => {
          // console.log(response);
          if (f.action == "download") {
            window.open(response.data);
          } else {
            this.successMessage = response.data;
          }
        });
    },
    checkDeletPermissions() {
      var permittedActions = this.$root.store.permittedActions;

      if (permittedActions) {
        permittedActions.forEach((a) => {
          if (
            a.can_delete_attachments ||
            this.$root.roles.some((role) => role.toLowerCase() === "admin")
          ) {
            this.noDelete = false;
          }
        });
      }
    },
    dataURItoBlob(dataURI) {
      // convert base64/URLEncoded data component to raw binary data held in a string
      var byteString;
      if (dataURI.split(",")[0].indexOf("base64") >= 0)
        byteString = atob(dataURI.split(",")[1]);
      else byteString = unescape(dataURI.split(",")[1]);

      // separate out the mime component
      var mimeString = dataURI
        .split(",")[0]
        .split(":")[1]
        .split(";")[0];

      // write the bytes of the string to a typed array
      var ia = new Uint8Array(byteString.length);
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }

      return new Blob([ia], { type: mimeString });
    },
    getDropzoneUrl() {
      this.dropzoneOptions.url =
        fun.getServerURL() +
        "/upload_file?" +
        "portal=" +
        this.portal +
        "&record_id=" +
        this.recordId +
        "&object_name=" +
        this.objName;
    },
    getFileData(file) {
      if (!this.$refs.myVueDropzone) {
        return;
      }
      this.$refs.myVueDropzone.getAcceptedFiles().forEach((f) => {
        var reader = new FileReader();
        reader.onload = () => {
          var fileAsBinaryString = reader.result;
          reader.readAsDataURL(f);
          console.log(reader);
          // do whatever you want with the file content
          //console.log(fileAsBinaryString);
        };
        reader.readAsArrayBuffer(f); //arraybuffer is what you  looking for
        console.log(reader);
      });
    },
    onFileRemoved(file) {
      console.log(file);
      console.log(this.uploadedFiles);
      var fileToDelete = this.uploadedFiles.find((f) => {
        return f.name == file.name;
      });

      var data = {
        portal: this.portal,
        object_name: this.objName,
        record_id: this.recordId,
        filename: fileToDelete.path,
      };

      axios
        .post(this.serverURL + "/delete_file", data, {
          withCredentials: true,
        })
        .then((r) => {
          this.$root.$emit("fileDeleted", { file: fileToDelete });
        });
    },
    fileUploaded(file, response) {
      this.$root.$emit("fileUploaded", { file: file, response: response });
      // console.log("Server response:", response);
      this.uploadedFiles.push({
        name: file.name,
        path: response.path,
      });
      this.getFiles({
        portal: this.portal,
        object_name: this.objName,
        record_id: this.recordId,
      });
      if (response.uploaded) {
        this.successMessage = "Data has been imported";
      }
    },
    getFileName(file) {
      var ext = file.name.split(".")[1];
      if (!this.acceptedFiles.includes(ext)) {
        this.errorMessage = "Extension is not allowed";
        return false;
      }
      if (!this.images.length) {
        this.mainImage = file.name;
      }
      console.log(file);
      // this.getFileData(file);
    },
    submit() {
      this.$refs.myVueDropzone.processQueue();
    },
    deleteFile(fileName, isDropBox) {
      var that = this;
      var data = {
        portal: this.portal,
        object_name: this.objName,
        record_id: this.recordId,
        filename: fileName.name ? fileName.name : fileName,
      };
      this.$root.$confirm
        .open("Delete", "Confirm deleting file?", {
          color: "red",
        })
        .then((confirm) => {
          if (confirm) {
            if (!isDropBox) {
              axios
                .post(this.serverURL + "/delete_file", data, {
                  withCredentials: true,
                })
                .then((response) => {
                  this.getFiles(data);
                });
            } else {
              var dFiles = that.dropBoxFiles.find((b) => {
                return b.title == fileName;
              });

              dFiles.chunks.forEach((d) => {
                // var myFile = that.files.find((f) => {
                //   return f.name == d.path;
                // });
                this.par.model.dropbox_files = this.par.model.dropbox_files.filter(
                  (f) => {
                    return f != d.path;
                  }
                );
                that.dropBoxFiles = that.dropBoxFiles.filter((f) => {
                  return f.title != fileName;
                });

                this.getFromDropBox(d.path, true);
              });
            }
            try {
              this.par.submit(false, false);
            } catch (error) {
              //
            }
          }
        });
    },
    checkFilter(f) {
      var included = true;
      if (this.filter) {
        this.filter.forEach((s) => {
          if (!this.filterExact) {
            if (f.indexOf(s) > -1) {
              included = false;
            }
          } else {
            if (f === s) {
              included = false;
            }
          }
        });
      }
      return included;
    },
    getDropBoxFiles(dFiles) {
      var title = "";
      var fileObj = {};
      dFiles.forEach((d) => {
        // console.log(d);
        var fileName = fun.splitByLastCharacter(d.name, ".")[0];
        var objTitle = fun.splitByLastCharacter(fileName, "_")[0];
        if (objTitle != title) {
          title = objTitle;
          fileObj = {};
          fileObj.title = title;
          fileObj.chunks = [];
          this.dropBoxFiles.push(fileObj);
        }
        var chunk = fun.splitByLastCharacter(fileName, "_")[1];
        if (!isNaN(parseInt(chunk))) {
          chunk = parseInt(chunk);
        }
        fileObj.chunks.push({ path: d.name, name: chunk });

        //
      });
      this.dropBoxFiles.forEach((df) => {
        df.chunks.sort((a, b) => a - b);
      });
      console.log(this.dropBoxFiles);
    },
    getFiles(data) {
      this.files = [];
      this.images = [];

      if (this.par && this.formModel.item && this.formModel.qty) {
        this.childPath = "\\inventory\\" + this.formModel._id;
      }
      data.child_object = this.childPath;
      var that = this;
      axios
        .post(this.serverURL + "/get_files", data, {
          withCredentials: true,
        })
        .then((response) => {
          var allFiles = response.data;
          that.$root.$emit("gotFiles", {
            files: allFiles,
            obj: that,
          });

          if (allFiles) {
            this.fileLength = allFiles.length;
            var dFiles = allFiles.filter((f) => {
              return f.dropbox;
            });
            if (dFiles.length) {
              this.getDropBoxFiles(dFiles);
            }

            allFiles.forEach((f) => {
              var included = true;
              if (this.filter) {
                included = this.checkFilter(f.name);
              }
              if (included && !f.dropbox) {
                if (f.name && f.name.split(".").length > 1) {
                  if (
                    that.imgExt.includes(f.name.split(".")[1].toLowerCase())
                  ) {
                    that.images.push(f);
                  } else {
                    that.files.push(f);
                  }
                } else {
                  that.files.push({ name: f });
                }
              }
            });
            that.mainImage = that.images.length ? that.images[0] : "";
            if (that.vModel) {
              if (that.images.includes(that.vModel)) {
                that.mainImage = that.vModel;
              }
            }
            if (that.formModel && that.formModel.main_image) {
              that.mainImage = { name: that.formModel.main_image };
            }
            this.docs = 1;
          }
        });
    },
  },
  computed: {
    sortedDropBoxFiles() {
      return this.dropBoxFiles.map((d) => ({
        ...d,
        chunks: [...d.chunks].sort((a, b) => Number(a.name) - Number(b.name)),
      }));
    },
  },

  watch: {
    mainImage() {
      if (this.formModel) {
        this.formModel.main_image = this.mainImage.name;
        var path = this.dir + "/" + this.mainImage.name;
        this.formModel.main_image_path = fun.normalizePath(path);
        this.$emit("input", this.mainImage);
        this.$root.$emit("imageUploaded", this);
      }
    },
  },
};
</script>

<style lang="css" scoped>
.in-line {
  display: inline-block;
  margin: 5px;
  position: relative;
  height: 128px;
}
.delete-icon {
  vertical-align: top;
}
</style>
